import React from "react";

const TemarioDiplomaturaMarketingMedico = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Fundamentos del marketing médico"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Qué es el Marketing Médico y por qué es clave hoy"}</span></li>
                <li><span className="fw-light">{"Diferencias entre marketing en salud pública, privada y ejercicio liberal"}</span></li>
                <li><span className="fw-light">{"Casos reales: aciertos y errores"}</span></li>
                <li><span className="fw-light">{"Marca personal y profesional"}</span></li>
                <li><span className="fw-light">{"Cómo posicionarte como referente confiable"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Conceptos de marketing"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Tono de voz, valores y diferencial profesional"}</span></li>
                <li><span className="fw-light">{"Estudio de mercado"}</span></li>
                <li><span className="fw-light">{"Análisis FODA aplicado a profesionales de la salud"}</span></li>
                <li><span className="fw-light">{"Canvas de negocios"}</span></li>
                <li><span className="fw-light">{"Objetivos SMART"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Redes sociales para profesionales de la salud"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"La importancia de las redes sociales para potenciar el perfil profesional en salud"}</span></li>
                <li><span className="fw-light">{"Selección de la red adecuada"}</span></li>
                <li><span className="fw-light">{"Criterios para evaluar la sostenibilidad en la gestión de redes"}</span></li>
                <li><span className="fw-light">{"Equilibrio entre contenido educativo y promocional"}</span></li>
                <li><span className="fw-light">{"Errores comunes en redes sociales y cómo evitarlos"}</span></li>
                <li><span className="fw-light">{"Buenas prácticas con ejemplos reales"}</span></li>
                <li><span className="fw-light">{"Difusión científica adaptada a entornos digitales"}</span></li>
                <li><span className="fw-light">{"Resumen y consejos finales sobre la clase"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Publicidad y gestión de redes sociales"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"La importancia de la calendarización y organización de contenidos"}</span></li>
                <li><span className="fw-light">{"Uso de ChatGPT: generación de ideas, redacción de copys, simplificación de textos técnicos, entre otras"}</span></li>
                <li><span className="fw-light">{"Construcción de comunidad confianza, empatía y fidelización"}</span></li>
                <li><span className="fw-light">{"Ejemplos de contenido para interacción con pacientes y seguidores"}</span></li>
                <li><span className="fw-light">{"Presencia digital como una red de puntos de contacto"}</span></li>
                <li><span className="fw-light">{"Recomendaciones finales para optimizar la presencia profesional en redes sociales"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Conocer al paciente: segmentación y métricas"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"¿Por qué segmentar?"}</span></li>
                <li><span className="fw-light">{"Arquetipos de pacientes"}</span></li>
                <li><span className="fw-light">{"Métricas"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Publicidad en redes"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Introducción a la publicidad digital en salud"}</span></li>
                <li><span className="fw-light">{"Publicidad en Meta Ads (Facebook e Instagram)"}</span></li>
                <li><span className="fw-light">{"Publicidad en Google Ads"}</span></li>
                <li><span className="fw-light">{"Estrategias combinadas y optimización"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"El mundo audiovisual"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Estrategia y comunicación médica"}</span></li>
                <li><span className="fw-light">{"Aspectos básicos de la creación de video"}</span></li>
                <li><span className="fw-light">{"Herramientas con ejercicios guiados"}</span></li>
                <li><span className="fw-light">{"Diseños y plantillas"}</span></li>
                <li><span className="fw-light">{"Cómo usar y adaptar plantillas profesionales para redes"}</span></li>
                <li><span className="fw-light">{"Tipografías y colores"}</span></li>
                <li><span className="fw-light">{"Selección de tipografías legibles y paletas de colores"}</span></li>
                <li><span className="fw-light">{"Formatos y dimensiones"}</span></li>
                <li><span className="fw-light">{"Elegir el tamaño correcto según el uso"}</span></li>
                <li><span className="fw-light">{"Uso de elementos gráficos"}</span></li>
                <li><span className="fw-light">{"Animaciones simples"}</span></li>
                <li><span className="fw-light">{"Agregar movimiento a textos o elementos gráficos para publicaciones"}</span></li>
                <li><span className="fw-light">{"Exportar imágenes y videos"}</span></li>
                <li><span className="fw-light">{"Descargar en formatos adecuados, resolución y calidad profesional"}</span></li>
                <li><span className="fw-light">{"Importar y organizar el contenido"}</span></li>
                <li><span className="fw-light">{"Herramienta de corte y edición básica"}</span></li>
                <li><span className="fw-light">{"Recortar, dividir o unir clips para ajustar duración y contenido"}</span></li>
                <li><span className="fw-light">{"Incorporar texto y subtítulos"}</span></li>
                <li><span className="fw-light">{"Transiciones y efectos visuales"}</span></li>
                <li><span className="fw-light">{"Música y efectos de sonidos"}</span></li>
                <li><span className="fw-light">{"Incorporación de hooks o ganchos"}</span></li>
                <li><span className="fw-light">{"Aprender a captar la atención del espectador en los primeros segundos"}</span></li>
                <li><span className="fw-light">{"Exportación de video"}</span></li>
                <li><span className="fw-light">{"Evaluación de un video: del material original a la versión final"}</span></li>
                <li><span className="fw-light">{"La filmación: cuidar cada detalle"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Cómo hablar frente a cámara"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Fundamentos de la expresión oral"}</span></li>
                <li><span className="fw-light">{"Lenguaje corporal frente a cámara"}</span></li>
                <li><span className="fw-light">{"Presencia y conexión visual"}</span></li>
                <li><span className="fw-light">{"Claridad y entonación"}</span></li>
                <li><span className="fw-light">{"Errores frecuentes a evitar"}</span></li>
                <li><span className="fw-light">{"Preparación y recursos prácticos"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"LinkedIn y relaciones públicas"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"LinkedIn: Cómo generar contenido que eduque y posicione"}</span></li>
                <li><span className="fw-light">{"Manejo de reputación online: cómo gestionar reseñas positivas y negativas"}</span></li>
                <li><span className="fw-light">{"Cómo hablar con los medios: alianzas, networking y vocería profesional"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Métricas"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Introducción al concepto de métricas en marketing médico"}</span></li>
                <li><span className="fw-light">{"Cómo leer e interpretar métricas"}</span></li>
                <li><span className="fw-light">{"Herramientas útiles y de fácil acceso"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"IA para marketing"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Introducción a la Inteligencia Artificial (IA) en marketing médico"}</span></li>
                <li><span className="fw-light">{"IA para organización y planificación de contenidos"}</span></li>
                <li><span className="fw-light">{"IA para diseño y edición de materiales visuales"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Gestión con estrategia"}</b>
            <br />
            <br />
            <ul>
                <li><span className="fw-light">{"Qué es una organización"}</span></li>
                <li><span className="fw-light">{"Recursos"}</span></li>
                <li><span className="fw-light">{"Proceso Administrativo"}</span></li>
                <li><span className="fw-light">{"Medicina legal"}</span></li>
            </ul>
            <br />
            <br />
            <b>{"Inteligencia artificial en el consultorio y las instituciones de salud"}</b>
            <br />
            <br />
        </div>
    );
};

export default TemarioDiplomaturaMarketingMedico;
